function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { AlreadyInitializedError, NotInNodeError } from '../error/error';
import { initBackForward, initChangeWindow, isBackForward } from './lib/eventInitHelper';
import { events } from './lib/mauthEvent';
import { MauthHttpClient } from './lib/mauthHttpClient';
import { MauthUser } from './lib/mauthUser';
class Mauth {
    async init(option) {
        if (this.initialized) {
            throw AlreadyInitializedError;
        }
        if (typeof window === 'undefined') {
            throw NotInNodeError;
        }
        this.initialized = true;
        this.mauth_http_client.init(option);
        this.mauth_user.setUser(await this.mauth_http_client.sessionCheck());
        await this.initEvent();
    }
    async sessionCheck() {
        try {
            const user = await this.mauth_http_client.sessionCheck();
            // 현재 페이지가 그려질 때 로그인 한 유저와 현재 유저가 다른 경우
            if (user && this.mauth_user.user && user.uid !== this.mauth_user.user.uid) {
                return document.dispatchEvent(events.DifferentUser);
            }
            if (!user && this.mauth_user.user) {
                return document.dispatchEvent(events.Logout);
            }
            // 세션이 그대로 살아 있는데 updated_at이 다른 경우
            if (user && this.mauth_user.user && user.updated_at !== this.mauth_user.user.updated_at) {
                document.dispatchEvent(events.UserUpdate);
                this.mauth_user.setUser(user);
                return;
            }
        } catch (e) {
            console.error(e);
        }
    }
    async initEvent() {
        if (isBackForward()) await this.sessionCheck();
        await initBackForward(this.sessionCheck.bind(this));
        initChangeWindow(this.sessionCheck.bind(this));
    }
    addEventListener(event, handler) {
        document.addEventListener("Mauth".concat(event), handler);
    }
    removeEventListener(event, handler) {
        document.removeEventListener("Mauth".concat(event), handler);
    }
    getUser() {
        return this.mauth_user.user;
    }
    async refreshUser() {
        this.mauth_user.setUser(await this.mauth_http_client.sessionCheck());
    }
    isLogin() {
        return this.mauth_user.isLogin();
    }
    constructor(){
        _define_property(this, "mauth_user", new MauthUser());
        _define_property(this, "mauth_http_client", new MauthHttpClient());
        _define_property(this, "initialized", false);
    }
}
export const mauth = new Mauth();
